<div id="my-ranking">
    <h2>{{ 'achievement-my-ranking.title' | translate }}</h2>
    <div *ngIf="!(loadingSubject | async) else loading">
        <dl class="my-ranking__list" *ngFor="let userPoints of userPoints">
            <dt class="my-ranking__list__label cdk-visually-hidden"
                aria-hidden="true">{{ 'achievement-my-ranking.player' | translate }}</dt>
            <dd class="my-ranking__list__name"
                *ngIf="userInformation$ | async as userInformation">{{userInformation?.get('label')}}</dd>
            <dt class="my-ranking__list__label cdk-visually-hidden"
                aria-hidden="true">{{ 'achievement-my-ranking.score' | translate }}</dt>
            <dd class="my-ranking__list__points">{{userPoints.get('score')}}</dd>
            <dt class="my-ranking__list__label cdk-visually-hidden"
                aria-hidden="true">{{ 'achievement-my-ranking.ranking' | translate }}</dt>
            <dd class="my-ranking__list__ranking">{{userPoints.get('rank')}}</dd>
        </dl>
    </div>

    <ng-template #loading>
        <div>
            <dl class="my-ranking__list">
                <dt class="my-ranking__list__label cdk-visually-hidden"
                    aria-hidden="true">{{ 'achievement-my-ranking.player' | translate }}</dt>
                <dd class="my-ranking__list__name"
                    *ngIf="userInformation$ | async as userInformation">{{userInformation?.get('label')}}</dd>
                <dt class="my-ranking__list__label cdk-visually-hidden"
                    aria-hidden="true">{{ 'achievement-my-ranking.score' | translate }}</dt>
                <dd class="my-ranking__list__points">-</dd>
                <dt class="my-ranking__list__label cdk-visually-hidden"
                    aria-hidden="true">{{ 'achievement-my-ranking.ranking' | translate }}</dt>
                <dd class="my-ranking__list__ranking">-</dd>
            </dl>
        </div>
    </ng-template>
</div>
